import { Component, inject, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from "rxjs/operators";
import { fromToolbar, ToolbarActions } from 'shared/classroom/toolbar/data-access';
import { ToolbarButtonComponent } from '../toolbar-button.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'pcp-slide-sync-toolbar-button-select',
    templateUrl: './toolbar-button-select.component.html',
    styleUrls: ['./toolbar-button-select.component.scss'],
    imports: [ToolbarButtonComponent, AsyncPipe]
})
export class ToolbarButtonSelectComponent {

    @Input() icon = 'open_with';
    @Input() fontSet = '';

    private readonly store: Store = inject(Store);

    readonly isDisabled$ = this.store.select(
        fromToolbar.isDrawingEnabled
    ).pipe(
        map(isDrawingEnabled => !isDrawingEnabled),
    );

    readonly isActivated$ = this.store.select(
        fromToolbar.selectActivatedDrawingTool
    ).pipe(
        map(activatedTool => activatedTool === 'selection')
    );

    public toggle() {
        this.store.dispatch(
            ToolbarActions.toggleDrawingTool({ toolName: 'selection' })
        );
    }
}

